import React from "react";
import PageMeta from "../components/common/PageMeta";
import ProductGrid from "../components/product/ProductGrid";
import siteConfig from "../config/siteConfig";
import { useCommerce } from "../hooks/useCommerce";

const WishlistPage = () => {
  const { wishlistItems } = useCommerce();
  return (
    <div className="wishlist-page site-container">
      <PageMeta title="Wishlist" description={`Your saved ${siteConfig.displayName} pantry picks.`} />
      <header className="page-heading"><p className="eyebrow">Saved for later</p><h1>Your wishlist</h1><p>Keep a short list of the flavors you want to explore next.</p></header>
      <ProductGrid products={wishlistItems} columns={4} emptyTitle="Your wishlist is empty" emptyDescription="Tap the heart on any product to save it here." emptyActionLabel="Explore the pantry" emptyActionTo="/shop" />
    </div>
  );
};

export default WishlistPage;
